import { IconButton, TableCell, TableRow, Typography } from "@mui/material"
import { formatDate } from "utils/HelperFunctions"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { AppColors } from "resources/AppColors";

const FormToDisplay = ({ form, handleShowEditModal, handleShowDeleteModal, canEditDelete }) => (
  <TableRow
    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
  >
    <TableCell align="left">
      <Typography variant='body'>{form.formName ? form.formName : form.name}</Typography>
    </TableCell>
    <TableCell align="left">
      <Typography variant='body'>{form.formId ? form.formId : form.id}</Typography>
    </TableCell>
    <TableCell align="left">
      <Typography variant='body'>{form.studyId ? form.studyId : form.studiesFormId}</Typography>
    </TableCell>
    <TableCell align="left">
      <Typography variant='body'>{form.formTag ? form.formTag : '-'}</Typography>
    </TableCell>
    <TableCell align="left">
      <Typography variant='body'>{form.formDescription ? form.formDescription : '-'}</Typography>
    </TableCell>
    <TableCell align="left">
      <Typography variant='body'>{form.startDate ? formatDate(form.startDate) : '-'}</Typography>
    </TableCell>
    <TableCell align="left">
      <Typography variant='body'>{form.endDate ? formatDate(form.endDate) : '-'}</Typography>
    </TableCell>
    <TableCell align="center" p={0}>
      {canEditDelete && handleShowEditModal &&
        <IconButton onClick={() => handleShowEditModal(form)} size="large">
          <EditIcon sx={{ fill: AppColors.PRIMARY }} />
        </IconButton>}
      {canEditDelete && handleShowDeleteModal &&
        <IconButton onClick={() => handleShowDeleteModal(form.formTag)} size="large">
          <DeleteIcon sx={{ fill: AppColors.PRIMARY }} />
        </IconButton>}
    </TableCell>
  </TableRow>
)

export default FormToDisplay